var exports = {
  "j": "Modals.module__modals___dE42Q2",
};

module.exports = exports;
